module.exports = "/_next/static/images/rolex_model_background_gold_landscape-d1d8c0d7351788dc2482b6ea42dcd373.jpg";